import { ICON_TYPE } from "@/components/library/Icon";

export type InsuranceIntegrationIcon = {
  icon: string;
  type: ICON_TYPE;
};

/** Logo assets for insurance landing integrations (`public/integrations/`). */
export const INSURANCE_INTEGRATION_LOGOS: Record<string, string | string[]> = {
  Vertafore: "/integrations/vertafore.png",
  "Applied Epic": "/integrations/applied-epic.webp",
  EZLynx: "/integrations/ezlynx.webp",
  HawkSoft: "/integrations/hawksoft.png",
  "Bold Penguin": "/integrations/bold-penguin.webp",
  Tarmika: "/integrations/tarmika.webp",
  "Salesforce FSC": "/integrations/salesforce.svg",
  "Calendly · iClosed": "/integrations/calendly.svg",
};

/**
 * Font Awesome icon fallbacks for integrations that have no brand logo asset
 * (e.g. catch-all entries). Rendered via the shared `Icon` component.
 */
export const INSURANCE_INTEGRATION_ICONS: Record<string, InsuranceIntegrationIcon> =
  {
    "Carrier APIs": {
      icon: "tower-broadcast",
      type: ICON_TYPE.DUOTONE,
    },
  };

export function getInsuranceIntegrationLogos(name: string): string[] {
  const logo = INSURANCE_INTEGRATION_LOGOS[name];
  if (!logo) {
    return [];
  }
  return Array.isArray(logo) ? logo : [logo];
}

export function getInsuranceIntegrationIcon(
  name: string,
): InsuranceIntegrationIcon | null {
  return INSURANCE_INTEGRATION_ICONS[name] ?? null;
}
